import { publicApiClient } from "@/api/axiosInstance";
import { API_ENDPOINTS, resolveEndpoint } from "@/api/endpoints";
import { useAuthStore } from "@/store/auth.store";

export const isTokenExpired = () => {
	const expiresAt = useAuthStore.getState().expiresAt;

	if (!expiresAt) return true;

	const bufferTime = 5 * 60 * 100;

	return Math.floor(Date.now() / 1000) + bufferTime >= Number(expiresAt);
};

export const refreshAccessToken = async (): Promise<string | null> => {
	try {
		const { refreshToken, isSuperAdmin, isBrand, brandId } =
			useAuthStore.getState();

		if (!refreshToken) {
			return null;
		}

		const body =
			isSuperAdmin === "true" && isBrand === "false"
				? { refreshToken }
				: { refreshToken, brandId };

		const response = await publicApiClient.post(
			resolveEndpoint(API_ENDPOINTS, ["AUTH", "REFRESH"]),
			body
		);

		const {
			accessToken,
			refreshToken: newRefreshToken,
			expiresAt
		} = response.data;

		useAuthStore.getState().setAuth({
			accessToken,
			refreshToken: newRefreshToken,
			expiresAt
		});

		return accessToken;
	} catch (_error) {
		useAuthStore.getState().resetAuth();
		return null;
	}
};
